module.exports = __webpack_public_path__ + "static/media/SAP_TEMPLATE.870ee972.xlsx";